import { render, staticRenderFns } from "./BundlePackageShow.vue?vue&type=template&id=77904eb6&"
import script from "./BundlePackageShow.vue?vue&type=script&lang=js&"
export * from "./BundlePackageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports